import React from 'react';

import { Label, StyledCharacterCount } from './CharacterCount.style';

export interface CharacterCountProps {
    count?: number;
    error?: boolean;
}

export function CharacterCount({ count = 0, error = false }: CharacterCountProps) {
    return (
        <StyledCharacterCount $error={error}>
            <Label>{count}</Label>
        </StyledCharacterCount>
    );
}
